module.exports = __webpack_public_path__ + "img/fc0a399.png";